import { render, staticRenderFns } from "./RoySimpleText.vue?vue&type=template&id=2f67d7f3&"
import script from "./RoySimpleText.vue?vue&type=script&lang=js&"
export * from "./RoySimpleText.vue?vue&type=script&lang=js&"
import style0 from "./RoySimpleText.vue?vue&type=style&index=0&id=2f67d7f3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports